// extracted by mini-css-extract-plugin
module.exports = {"labelIn":"labelIn-tfa6K","input":"input-1JVzf","label":"label-2shvs"};